import { useEffect, useMemo, useRef, useState } from 'react';
import { api } from '../api.ts';
/* `Dialog` STAND HIER UND WIRD NICHT MEHR GEBRAUCHT. Diese Planung ist seit
   .112 Seite 3 von „Auftrag vorbereiten" und kein eigenes Fenster mehr. */
import { Fehlerkasten, ausFehler, type Fehlerlage }
  from '../teile/Formular.tsx';
import { grubenRadius, type Kartenlage, type Punkt }
  from '../teile/Tiefbaukarte.tsx';
import Kartenflaeche from '../teile/Kartenflaeche.tsx';
import { START_PLANUNG } from '../teile/kartenstart.ts';
import KeinePunkte from '../teile/KeinePunkte.tsx';
import Punktgenauigkeit from '../teile/Punktgenauigkeit.tsx';
import { meterZwischen } from '../teile/grabenlaenge.ts';
import {
  bezugshelligkeit, probeAn, schlageVor,
  stellenAmAbschnitt, stellenAnDerGrube, type Probe,
} from '../teile/oberflaeche.ts';

/**
 * Planung Tiefbauaufwand.
 *
 * ORIGINALTEXT MARVIN (19.08.2026)
 *   „wir nehmen den Lageplan und zeichnen so grob den leitungsweg der Telekom
 *    ab dem rohrverbsnd zum Kunden nach. Das System hat dann klare Marker,
 *    dadurch die Länge und muss dann nur noch die Abschnitte selbst selektieren
 *    zwecks der Oberfläche und Vorschläge machen was es sein kann. Der Mensch
 *    kann es dann ggf. ändern."
 *
 * ORIGINALTEXT MARVIN (19.08.2026)
 *   „es hat nichts mit dem lap_maps zu tun. Denn der darf nur die öffentlichen
 *    Bereiche beinhalten weil wir diesen ja weiter zur Behörde senden. Das
 *    andere ist nur intern für uns."
 *
 * WER RECHNET WAS: dieses Fenster rechnet für die ANZEIGE, der Server rechnet,
 * was gespeichert wird - aus den Koordinaten, nicht aus einer mitgeschickten
 * Meterzahl. Früher kam die Meterzahl aus dem Browser und wurde ungeprüft
 * übernommen; damit war der geschätzte Aufwand eine Behauptung des Fensters.
 */

type Werkzeug = 'weg' | 'grube';

interface Rohabschnitt {
  a: Punkt; b: Punkt; klasse: string; leerrohr: boolean;
  handisch: boolean; vorschlag: string | null; sicherheit: number | null;
}
interface Rohgrube { punkt: Punkt; klasse: string; handisch: boolean; }

/* DIE LUFTLINIE STEHT IN `teile/grabenlaenge.ts`.
 *
 * Sie stand hier, also in einer Datei mit JSX - an einer Stelle, die ein
 * Prüfstand nur mit einer Textsuche erreicht. **Eine Textsuche misst, dass
 * etwas dasteht, nicht, dass es stimmt**, und diese Formel steht wörtlich ein
 * zweites Mal im Server (`regeln/tiefbau.ts`). Sie liegt jetzt daneben, ohne
 * JSX, und Prüfstand 123 legt beide Fassungen über eine Reihe von Punkten
 * gegeneinander - derselbe Umzug wie bei den Oberflächenregeln. */

/* DIE OBERFLÄCHENREGELN STEHEN IN `teile/oberflaeche.ts`.
 *
 * Hier standen `probe`, `exg` und `schlageVor` als eigene Fassung neben der
 * des Servers - in einer Datei mit JSX, also an einer Stelle, die ein
 * Prüfstand nur mit einer Textsuche erreicht. **Eine Textsuche misst, dass
 * etwas dasteht, nicht, dass es stimmt.** Sie liegen jetzt daneben, ohne JSX,
 * und Prüfstand 086 legt sie über eine Reihe von Proben gegen die Fassung des
 * Servers. */

/* DAS WUNSCHMASS DER KARTE, UND ZUGLEICH IHR DECKEL.
 *
 * Es war bis zum 03.09.2026 die WIRKLICHE Grösse, und damit lief dieses
 * Fenster auf einem nicht ganz aufgezogenen Bildschirm nach rechts hinaus -
 * dort, wo die Werte stehen. Gemessen wird die Spalte (`Kartenflaeche` hält
 * den Messfühler); das Verhältnis bleibt, damit der Ausschnitt im Fenster
 * derselbe ist wie in der Rechnung darunter.
 *
 * HIER STANDEN BIS .107 ZWEI PAARE - eines für das Fenster und ein grösseres
 * für die Seite. Den Menüpunkt gibt es nicht mehr (Marvin, 04.09.2026: „wir
 * entfernen wieder den menüpunkt mit der karte"), also gibt es auch nur noch
 * einen Ort und ein Mass. **Toten Code entfernen, nicht auskommentieren.** */
const BREITE = 760, HOEHE = 560;

/* „LEERROHR LIEGT" IST EIN EIGENER PUNKT MIT EINEM KÄSTCHEN.
 *
 * ORIGINALTEXT MARVIN (06.09.2026, zur Karte „Abschnitte und Gruben")
 *   „bei «Abschnitte und Gruben» fehlt der punkt Leehrrohr mit der Checkbox."
 *
 * ES IST DIE ZWEITE ENTSCHEIDUNG ZU DERSELBEN FRAGE, UND SIE GILT.
 * Am 03.09.2026 hatte er beanstandet, dass „lehrrohr" nirgends dasteht, wo man
 * es sucht: in der Legende unter der Karte als gestrichelter Balken, unter der
 * Auswahl als Satz - und BEDIENT über ein Kästchen in einer eigenen,
 * unbeschrifteten Spalte, das nur ein Tooltip erklärt hat. Lieferung .111 hat
 * daraus einen Eintrag in der Oberflächen-Auswahl gemacht („eine Frage, eine
 * Auswahl"). Der Auftraggeber will das Kästchen.
 *
 * **WAS AUS .111 BLEIBT, IST DIE LEHRE UND NICHT DIE BAUART:** das Kästchen
 * trägt seine Aufschrift NEBEN sich, sichtbar, nicht in einem Tooltip - einen
 * Tooltip gibt es auf dem Telefon nicht, und genau daran ist das alte
 * gescheitert. Und es steht in DERSELBEN Zelle wie die Auswahl, nicht in einer
 * eigenen Spalte: es beantwortet dieselbe Frage.
 *
 * **UND ES GIBT IHN NUR AM ABSCHNITT.** Ein Rohr wird durch einen Graben
 * eingezogen; eine Grube wird geöffnet, sonst ist sie keine.
 *
 * `LEERROHR` als Wert der Auswahl ist damit weg - toten Code entfernen, nicht
 * auskommentieren. Der Merker `leerrohr` je Abschnitt bleibt, wie er war: an
 * ihm hängen die Rechnung, die gestrichelte Linie auf der Karte und die
 * gespeicherte Zeile. */

/* HIER STAND EIN ZWEITES FENSTER ÜBER DEM ERSTEN.
 *
 * ORIGINALTEXT MARVIN (05.09.2026, Bild 4)
 *   „wenn ich die planung für den tiefbau anklicke, dann soll direkt hier die
 *    karte kommen, so wie bei dem vorbereiten zum tiefbau. ich brsuche keine
 *    erklärung oder nochmal ein popup. das ist unnnötig."
 *
 * **DIE PLANUNG IST SEITE 3 VON „AUFTRAG VORBEREITEN" UND KEIN EIGENES
 * FENSTER.** Bis .111 stand auf Seite 3 eine Zusammenfassung, zwei Karten
 * mit Erklärtext und ein Knopf; hinter dem Knopf ging ein ZWEITER Dialog über
 * dem ersten auf, und darin lag die Karte. Seite 1 macht es seit jeher
 * anders: dort liegt die Karte einfach da. **Zwei Seiten desselben Fensters,
 * die dieselbe Handbewegung verschieden verlangen, sind ein Bildschirm, den
 * man lernen muss.**
 *
 * DAMIT FÄLLT AUCH DER RAHMEN WEG, UND ZWAR GANZ. .107 hatte diese Planung an
 * zwei Orte gestellt und dafür einen Rahmen gebaut, der ein Fenster oder eine
 * Seite sein konnte; .108 hat den Menüpunkt zurückgenommen und den Rahmen
 * gleich mit. Jetzt gibt es wieder genau EINEN Ort - den Inhalt von Seite 3 -,
 * und ein Dialog daneben wäre wieder die Abzweigung, die niemand pflegt.
 * `zu` gibt es deshalb nicht mehr: geschlossen wird das Fenster, in dem diese
 * Seite steht.
 */

export default function Tiefbauplanung({ auftragId, fertig }: any) {
  const [d, setD] = useState<any>(null);
  const [lage, setLage] = useState<Kartenlage | null>(null);
  /* DIE MONTAGEGRUBE IST VORGEWÄHLT.
   *
   * ORIGINALTEXT MARVIN (03.09.2026)
   *   „bei der planung soll luftbild und grenzen aktiv sein und direkt die
   *    montagegrube ausgewählt."
   *
   * Und das ist mehr als eine Bequemlichkeit: die Grube ist der erste Griff.
   * Sie steht am Rohrverband, von ihr aus wird der Weg gezeichnet, und die
   * Umgebungsbilder nehmen sie als Anhaltspunkt. Wer mit „Weg" anfängt, setzt
   * seinen ersten Klick dorthin, wo die Grube hingehört, und muss ihn wieder
   * zurücknehmen. */
  const [werkzeug, setWerkzeug] = useState<Werkzeug>('grube');
  const [punkte, setPunkte] = useState<Punkt[]>([]);
  const [gruben, setGruben] = useState<Rohgrube[]>([]);
  const [klassen, setKlassen] = useState<Record<number, string>>({});
  /* Welche Oberflächen ein Mensch gesetzt hat. GETRENNT von `klassen`, weil
     `klassen` auch die gespeicherten Vorschläge trägt: sonst würde ein
     gespeicherter Vorschlag beim nächsten Öffnen durch einen NEUEN Vorschlag
     ersetzt, und der kann schlechter sein. Beim Wiederöffnen mit gestörtem
     Luftbild stünde plötzlich überall „Beton, 40 % sicher". */
  const [handisch, setHandisch] = useState<Record<number, boolean>>({});
  const [leerrohr, setLeerrohr] = useState<Record<number, boolean>>({});
  const [vorschlaege, setVorschlaege] = useState<
    Record<number, { klasse: string; sicherheit: number }>>({});
  /* Die Vorschläge für die GRUBEN, getrennt von denen der Abschnitte. Zwei
     Zählungen, zwei Listen: eine gemeinsame Liste hätte Abschnitt 2 und Grube
     2 denselben Schlüssel gegeben. */
  const [grubenVorschlag, setGrubenVorschlag] = useState<
    Record<number, { klasse: string; sicherheit: number }>>({});
  const [hef, setHef] = useState(1);
  const [leser, setLeser] = useState<((p: Punkt) => number[] | null) | null>(null);
  const [laeuft, setLaeuft] = useState(false);
  const [fehler, setFehler] = useState<Fehlerlage | null>(null);
  const [meldung, setMeldung] = useState<string | null>(null);

  useEffect(() => {
    api.tiefbau(auftragId).then((r: any) => {
      setD(r);
      const s = r.schaetzung;
      /* KEIN GERATENER PUNKT UND KEINE ZWEITE STARTSTUFE.
       *
       * Hier stand `?? { lat: 50.35, lng: 7.6 }` - die Mitte von Koblenz -
       * und `?? 20` neben dem `?? 19` des Lageplans. Beides ist weg: die
       * Stufe kommt vom Server (`kartenstufe.ts`), und ohne Koordinaten wird
       * gar keine Karte gezeigt, sondern der Weg zu einem echten Punkt. */
      const mitte = s?.mitte ?? r.mitte ?? null;
      if (mitte) setLage({ mitte, zoom: s?.zoom ?? r.startstufe });
      if (s?.abschnitte?.length) {
        // Aus den Abschnitten die Stützpunkte zurückgewinnen: Korrigieren ist
        // kein Neuanfang.
        const p: Punkt[] = [s.abschnitte[0].a];
        for (const a of s.abschnitte) p.push(a.b);
        setPunkte(p);
        const k: Record<number, string> = {}, l: Record<number, boolean> = {};
        const h: Record<number, boolean> = {};
        const v: Record<number, { klasse: string; sicherheit: number }> = {};
        s.abschnitte.forEach((a: any, i: number) => {
          k[i] = a.klasse;                 // AUCH der gespeicherte Vorschlag
          if (a.handisch) h[i] = true;
          if (a.leerrohr) l[i] = true;
          if (a.vorschlag) {
            v[i] = { klasse: a.vorschlag, sicherheit: a.sicherheit ?? 0 };
          }
        });
        setKlassen(k); setLeerrohr(l); setHandisch(h); setVorschlaege(v);
      }
      /* EINE GRUBE OHNE PUNKT WIRD ÜBERSPRUNGEN, NICHT GEZEICHNET.
         ----------------------------------------------------------------
         ORIGINALTEXT MARVIN (08.09.2026): „«planung für tiefbau» geht wieder
         nicht, behebe die fehler!"

         Der Rohwert trug zwei Formen (siehe `regeln/tiefbau.ts`,
         `grubeAus`), und `gruben.map((g) => nach(g.punkt))` las bei der
         fremden ein `undefined`. Das wirft in `nach`, und React reisst
         daraufhin den GANZEN Baum ab: nicht das Fenster wurde leer, sondern
         die SEITE.

         DER SERVER LIEFERT SEIT .136 EINE FORM. Diese Zeile ist der zweite
         Riegel und nicht die Behebung: **eine dritte Form darf morgen
         genauso wenig eine Seite töten wie diese zweite heute.** Was hier
         herausfällt, ist eine Grube, die niemand zeichnen kann - sie fehlt
         dann in der Zeichnung, und das ist sichtbar; eine weisse Seite ist
         es nicht. */
      const roheGruben = (Array.isArray(s?.gruben_punkte) ? s.gruben_punkte : [])
        .map((g: any) => {
          const p = g?.punkt ?? g;
          return Number.isFinite(Number(p?.lat)) && Number.isFinite(Number(p?.lng))
            ? { punkt: { lat: Number(p.lat), lng: Number(p.lng) },
                klasse: String(g?.klasse ?? 'unbekannt'),
                handisch: !!g?.handisch }
            : null;
        })
        .filter(Boolean) as Rohgrube[];
      if (roheGruben.length) setGruben(roheGruben);
      if (s?.hauseinfuehrungen) setHef(s.hauseinfuehrungen);
    }).catch((f) => setFehler(ausFehler(f)));
  }, [auftragId]);

  /* DIE OBERFLÄCHEN VORSCHLAGEN - FÜR ABSCHNITTE UND FÜR GRUBEN.
   *
   * ORIGINALTEXT MARVIN (03.09.2026)
   *   „die grube erkennt keinen untergrund."
   *
   * ER HAT RECHT, UND ES WAR KEINE UNGENAUIGKEIT, SONDERN EINE LÜCKE: dieser
   * Effekt lief ausschliesslich über `punkte`. Eine Grube entsteht mit
   * `klasse: 'unbekannt'` und blieb es, bis ein Mensch die Auswahl anfasste -
   * und in der Rechnung steht `unbekannt` mit 1,5 Stunden zwischen Grün (1,0)
   * und Beton (3,0). **Eine Pauschale für „weiss ich nicht" sieht in der
   * Summe genauso aus wie eine gemessene Zahl**, und die Grube ist der teurere
   * Posten: sie kostet pauschal, nicht je Meter.
   *
   * WAS ABGETASTET WIRD:
   *   Abschnitt   neun Stützstellen entlang der Linie, je anderthalb Meter
   *               senkrecht links und rechts davon
   *   Grube       die Mitte und acht Punkte auf einem Ring von 0,6 m - also
   *               innerhalb der Fläche, die wirklich geöffnet wird (eine
   *               Montagegrube ist rund anderthalb Meter breit)
   *
   * DIE BEZUGSHELLIGKEIT WIRD EINMAL GERECHNET, über die harten Flächen VON
   * BEIDEN. Ohne sie wäre „dunkel heisst Asphalt" eine Aussage über den
   * Sonnenstand; zweimal gerechnet gäbe sie einer Grube und dem Abschnitt, der
   * an ihr endet, zwei verschiedene Bezugswerte - und damit zwei verschiedene
   * Oberflächen an derselben Stelle.
   *
   * EIN VON HAND GESETZTER WERT WIRD NIE ÜBERSCHRIEBEN, hier wie dort. */
  useEffect(() => {
    if (!leser || !lage) return;
    if (punkte.length < 2 && !gruben.length) return;

    /* WO abgetastet wird, steht in `teile/oberflaeche.ts` - samt der
       Umrechnung von Metern in Grad, die für Länge und Breite VERSCHIEDEN
       ist. Hier stand sie mit einer Zahl für beide Achsen. */
    const alle: { i: number; p: Probe }[] = [];
    for (let i = 0; i < punkte.length - 1; i++) {
      const p = probeAn(stellenAmAbschnitt(punkte[i], punkte[i + 1]), leser);
      if (p) alle.push({ i, p });
    }

    const alleG: { i: number; p: Probe }[] = [];
    gruben.forEach((g, i) => {
      const p = probeAn(stellenAnDerGrube(g.punkt), leser);
      if (p) alleG.push({ i, p });
    });

    if (!alle.length && !alleG.length) return;

    const bezug = bezugshelligkeit([...alle, ...alleG].map((x) => x.p));

    const neu: Record<number, { klasse: string; sicherheit: number }> = {};
    for (const x of alle) neu[x.i] = schlageVor(x.p, bezug);
    if (alle.length) {
      setVorschlaege((alt) => ({ ...alt, ...neu }));
      // Nur die Abschnitte übernehmen, die noch KEINE Oberfläche haben. Ein
      // gesetzter Wert - von Hand oder aus einem früheren Vorschlag - bleibt.
      setKlassen((alt) => {
        const raus = { ...alt };
        for (const [i, v] of Object.entries(neu)) {
          if (raus[Number(i)] === undefined) raus[Number(i)] = v.klasse;
        }
        return raus;
      });
    }

    if (alleG.length) {
      const neuG: Record<number, { klasse: string; sicherheit: number }> = {};
      for (const x of alleG) neuG[x.i] = schlageVor(x.p, bezug);
      setGrubenVorschlag((alt) => ({ ...alt, ...neuG }));
      /* NUR EINE GRUBE OHNE ANTWORT BEKOMMT EINE. `handisch` schlägt jeden
         Vorschlag, und `unbekannt` ist hier der einzige Wert, der „noch nicht
         beantwortet" heisst - jeder andere steht da, weil ihn ein Mensch oder
         ein früherer Vorschlag gesetzt hat.

         UND ES MUSS DASSELBE FELD ZURÜCKKOMMEN, WENN SICH NICHTS ÄNDERT. Dieser
         Effekt hängt an `gruben`; gäbe er jedes Mal ein neues Feld zurück,
         liefe er sich selbst wieder an - und zwar für immer. */
      setGruben((alt) => {
        let geaendert = false;
        const raus: Rohgrube[] = alt.map((g, i) => {
          const v = neuG[i];
          if (!v || g.handisch || g.klasse !== 'unbekannt') return g;
          geaendert = true;
          return { ...g, klasse: v.klasse };
        });
        return geaendert ? raus : alt;
      });
    }
  }, [leser, punkte, gruben, lage?.zoom, lage?.mitte.lat, lage?.mitte.lng]);

  const abschnitte: Rohabschnitt[] = useMemo(() => {
    const raus: Rohabschnitt[] = [];
    for (let i = 0; i < punkte.length - 1; i++) {
      const v = vorschlaege[i];
      raus.push({
        a: punkte[i], b: punkte[i + 1],
        klasse: klassen[i] ?? v?.klasse ?? 'unbekannt',
        leerrohr: !!leerrohr[i],
        handisch: !!handisch[i],
        vorschlag: v?.klasse ?? null,
        sicherheit: v?.sicherheit ?? null,
      });
    }
    return raus;
  }, [punkte, klassen, leerrohr, vorschlaege, handisch]);

  // Für die Anzeige. Gespeichert wird, was der Server rechnet.
  const gerechnet = useMemo(() => {
    if (!d) return null;
    const w = d.werte;
    let meter = 0, leerM = 0, stunden = 0;
    const je: Record<string, number> = {};
    const zeilen = abschnitte.map((a, i) => {
      const m = meterZwischen(a.a, a.b);
      meter += m;
      let std = 0;
      if (a.leerrohr) { leerM += m; if (w.leerrohr > 0) std = m / w.leerrohr; }
      else {
        je[a.klasse] = (je[a.klasse] ?? 0) + m;
        if (w.mh[a.klasse] > 0) std = m / w.mh[a.klasse];
      }
      stunden += std;
      return { nr: i + 1, meter: m, stunden: std };
    });
    for (const g of gruben) stunden += w.grube[g.klasse] ?? 0;
    if (abschnitte.length || gruben.length) stunden += hef * w.hef + w.ruest;
    stunden *= 1 + (w.zuschlag || 0) / 100;
    return { meter, leerM, stunden, tage: stunden / (w.tag || 8), zeilen, je };
  }, [abschnitte, gruben, hef, d]);

  /* ES WIRD GELADEN, SOLANGE NICHTS DA IST - UND NUR SOLANGE.
   *
   * ORIGINALTEXT MARVIN (07.09.2026)
   *   „anderer innendienst benutzer kann «planung für tiefbau» nicht nutzen,
   *    es kommt eine weiße seite"
   *
   * **HIER STAND `if (!d || !lage)`, UND DAMIT WAR DER KASTEN DARUNTER TOTER
   * CODE.** `if (d && !lage)` kam nie an die Reihe: die Bedingung oben greift
   * bei fehlender Lage zuerst und gibt „Wird geladen." zurück - für immer.
   *
   * DAS TRIFFT NICHT EINEN BENUTZER, SONDERN EINEN AUFTRAG. Nachgezählt am
   * 07.09.2026: **317 von 406 Aufträgen haben keine Koordinaten** - nach der
   * Übernahme aus der alten Tabelle ist das der Regelfall, und der Lauf holt
   * 20 je Nacht nach. Wer einen davon aufmacht, sieht eine leere Fläche mit
   * einem kleinen grauen Satz, der eine Bewegung verspricht, die nie kommt.
   * Marvin hat es an einem anderen Zugang gesehen und daraus auf ein Recht
   * geschlossen; die Rechte sind es nicht (`innendienst` trägt beide).
   *
   * **EIN LADEHINWEIS, DER NICHT AUFHÖRT, IST EINE WEISSE SEITE.** Gewartet
   * wird nur auf das, was wirklich noch kommt: die Daten. Ist `d` da und die
   * Lage fehlt, ist das keine Wartezeit, sondern eine Auskunft - und die
   * steht im Kasten darunter. */
  if (!d) {
    return (
      <>
        <Fehlerkasten lage={fehler} />
        {!fehler && <p className="klein leise">Wird geladen.</p>}
      </>
    );
  }

  const farbe = (k: string) =>
    d.oberflaechen.find((o: any) => o.wert === k)?.farbe ?? '#8e97a4';
  const z1 = (n: number) => n.toFixed(1).replace('.', ',');

  async function uebernehmen() {
    setLaeuft(true); setFehler(null);
    try {
      const r = await api.tiefbauSpeichern(auftragId, {
        abschnitte, gruben, hef, mitte: lage!.mitte, zoom: lage!.zoom,
      });
      setMeldung(r.klartext);
      /* UND DER BILDSCHIRM DAHINTER ZIEHT NACH.
         ORIGINALTEXT MARVIN (08.09.2026): „Tiefbauaufwand erscheint erst
         nach Neuladen - automatischer Push statt Seite aktualisieren".
         Dieser Weg hat GESCHRIEBEN und niemandem Bescheid gesagt: `fertig`
         stand als Eigenschaft da und wurde von keiner Zeile gerufen.
         **Ein Rückruf, den niemand ruft, ist von einem fehlenden nicht zu
         unterscheiden** - der Aufwand stand in der Akte erst nach dem
         Neuladen der Seite. Er steht HINTER der Meldung und wirft nie: ein
         Übernehmen, das an einem Nachladen scheitert, wäre die teuerste
         Art Sorgfalt. */
      try { await fertig?.(); } catch { /* geschrieben ist geschrieben */ }
    } catch (f) { setFehler(ausFehler(f)); }
    finally { setLaeuft(false); }
  }

  /* OHNE KOORDINATEN WIRD NICHTS GEZEICHNET, sondern gesagt, was zu tun ist -
     mit demselben Kasten wie im Lageplan. Er lädt danach neu: mit dem Punkt
     kommen Luftbild, Grenzen und der ganze Rest, und das entscheidet der
     Server. */
  if (!lage) {
    return (
      <>
        <Fehlerkasten lage={fehler} />
        <KeinePunkte
          auftragId={auftragId} text={d.ohneMitte ?? ''}
          anschrift={d.anschrift}
          fertig={() => {
            api.tiefbau(auftragId).then((r: any) => {
              setD(r);
              const m = r.schaetzung?.mitte ?? r.mitte ?? null;
              if (m) {
                setLage({ mitte: m,
                          zoom: r.schaetzung?.zoom ?? r.startstufe });
              }
            }).catch(() => {});
          }} />
      </>
    );
  }

  return (
    <>
      {/* KEINE ÜBERSCHRIFT UND KEIN UNTERTITEL. Beides steht im Kopf des
          Fensters, in dem diese Seite liegt: „Auftrag vorbereiten" mit der
          vollen Anschrift daneben. Ein zweiter Titel darunter wäre dieselbe
          Auskunft ein zweites Mal - **und der Reiter darüber sagt schon,
          welche Seite man vor sich hat.** Der Merker „nur intern" bleibt: er
          sagt etwas, das aus der Seite selbst nicht hervorgeht. */}
      <p className="klein leise" style={{ marginTop: 0 }}>
        Nur intern. Die Zeichnung läuft bis ins Haus, also über Privatgrund;
        sie geht in kein Papier an eine Behörde und hat mit dem Lageplan
        nichts zu tun.
      </p>
      <Fehlerkasten lage={fehler} />

      {/* WOHER DER PUNKT KOMMT. Hier wiegt es schwerer als im Lageplan: über
          diesem Punkt wird die Trasse gezogen und der Aufwand geschätzt. Der
          ganze Absatz steht in `teile/Punktgenauigkeit.tsx`. */}
      <Punktgenauigkeit
        auftragId={auftragId} anschrift={d.anschrift}
        genauigkeit={d.punktgenauigkeit} hinweis={d.punkthinweis}
        fertig={() => {
          api.tiefbau(auftragId).then((r: any) => {
            setD(r);
            const m = r.schaetzung?.mitte ?? r.mitte ?? null;
            if (m) setLage({ mitte: m, zoom: r.schaetzung?.zoom ?? r.startstufe });
          }).catch(() => {});
        }} />

      <div className="spalten">
        <div className="spalte">
          {/* EINE KARTE FÜR BEIDE BEREICHE.
           *
           * ORIGINALTEXT MARVIN (04.09.2026)
           *   „beide Bereiche mit Lageplan vorbereiten für die gemeinde und
           *    planung für den tiefbau hat die gleiche kartenstruktur mit
           *    allem. es unterscheidet sich nur in dem was markiert ist beim
           *    starten und die symbole zur anzeichnung!"
           *
           * Die vier Haken, das Nachladen der Grenzen, das Messen der Spalte
           * und die zehn Vorlagen an `Tiefbaukarte` standen hier ein zweites
           * Mal - bis auf zwei Aufschriften Zeile für Zeile wie im Lageplan.
           * Sie stehen jetzt in `teile/Kartenflaeche.tsx`. Was DIESER Bereich
           * beisteuert, sind die zwei Dinge, die Marvin nennt: womit er
           * beginnt (`START_PLANUNG` - hier MIT Grenzen, denn wo die
           * Grundstücksgrenze verläuft, entscheidet, wo gegraben werden darf)
           * und was gezeichnet wird. */}
          <Kartenflaeche
            auftragId={auftragId}
            lage={lage} setzeLage={setLage}
            start={START_PLANUNG}
            daten={d}
            wunschBreite={BREITE} wunschHoehe={HOEHE}
            werkzeuge={<>
              {/* DIE SYMBOLE ZUR ANZEICHNUNG - hier ein nummerierter Weg in
                  der Farbe seiner Oberfläche und eine Grube als Quadrat.
                  DIE MONTAGEGRUBE IST VORGEWÄHLT (Marvin, 03.09.2026: „direkt
                  die montagegrube ausgewählt"): sie steht am Rohrverband, von
                  ihr aus wird der Weg gezeichnet, und die Umgebungsbilder
                  nehmen sie als Anhaltspunkt. */}
              {/* ER HEISST „GRABEN", WIE IM LAGEPLAN DANEBEN.
                  ORIGINALTEXT MARVIN (06.09.2026)
                    „«Weg» heißt «Graben»."
                  Zwei Aufschriften für dieselbe Handbewegung sehen nach zwei
                  Bildschirmen aus - dieselbe Falle wie bei „Grenzen" gegen
                  „Grundstücksgrenzen" am 04.09.2026. Der BEZEICHNER bleibt
                  `weg`: er läuft durch keinen Text, den ein Mensch liest. */}
              <button className={'knopf klein'
                        + (werkzeug === 'weg' ? ' haupt' : '')}
                      onClick={() => setWerkzeug('weg')}>Graben</button>
              <button className={'knopf klein'
                        + (werkzeug === 'grube' ? ' haupt' : '')}
                      onClick={() => setWerkzeug('grube')}>Montagegrube</button>
              <button className="knopf klein" onClick={() => {
                if (werkzeug === 'weg') setPunkte((p) => p.slice(0, -1));
                else setGruben((g) => g.slice(0, -1));
              }}>zurück</button>
              <button className="knopf klein" onClick={() => {
                /* AUCH DIE VORSCHLÄGE UND DAS „von Hand" GEHEN MIT. Sie
                   hängen an der Nummer des Abschnitts, und nach einem
                   Neuanfang trägt Abschnitt 1 einen ganz anderen Weg:
                   stehengeblieben behauptete der alte Vorschlag etwas über
                   eine Strecke, die es nicht mehr gibt. */
                setPunkte([]); setGruben([]); setKlassen({}); setLeerrohr({});
                setHandisch({}); setVorschlaege({}); setGrubenVorschlag({});
              }}>Neu</button>
            </>}
            rechts={
              <span className="klein leise">
                {punkte.length < 2 && !gruben.length ? 'noch nichts gezeichnet'
                  : `${abschnitte.length} Abschnitte, ${gruben.length} Gruben`}
              </span>
            }
            aufProbe={(l) => setLeser(() => l)}
            aufKlick={(p) => {
              if (werkzeug === 'weg') setPunkte((alt) => [...alt, p]);
              else setGruben((alt) => [...alt, { punkt: p, klasse: 'unbekannt',
                                                 handisch: false }]);
            }}
            kinder={(nach, mpp) => (
              <>
                {abschnitte.map((a, i) => {
                  const p = nach(a.a), q = nach(a.b);
                  const m = { x: (p.x + q.x) / 2, y: (p.y + q.y) / 2 };
                  return (
                    <g key={i}>
                      <line x1={p.x} y1={p.y} x2={q.x} y2={q.y}
                            stroke={farbe(a.klasse)} strokeWidth={13}
                            strokeLinecap="round"
                            strokeDasharray={a.leerrohr ? '5 10' : undefined} />
                      <line x1={p.x} y1={p.y} x2={q.x} y2={q.y}
                            stroke="#fff" strokeWidth={3}
                            strokeDasharray={a.leerrohr ? '5 10' : undefined} />
                      <circle cx={m.x} cy={m.y} r={11} fill="#1f3864"
                              stroke="#fff" strokeWidth={2} />
                      <text x={m.x} y={m.y + 4} textAnchor="middle" fill="#fff"
                            fontSize={11} fontWeight={700}>{i + 1}</text>
                    </g>
                  );
                })}
                {punkte.map((p, i) => {
                  const q = nach(p);
                  return <circle key={i} cx={q.x} cy={q.y} r={6} fill="#fff"
                                 stroke="#1f3864" strokeWidth={3} />;
                })}
                {gruben.map((g, i) => {
                  const q = nach(g.punkt);
                  // DIE GRUBE HAT EINE GRÖSSE IM GELÄNDE, keine in
                  // Bildpunkten (Marvin, 02.09.2026: „der ring ist immer in
                  // der gleichen größe und passt sich dem zoom nicht an").
                  const r = grubenRadius(mpp);
                  return (
                    <g key={i}>
                      <rect x={q.x - r} y={q.y - r} width={r * 2} height={r * 2}
                            rx={Math.max(2, r * 0.38)}
                            fill={farbe(g.klasse)} stroke="#e9954a"
                            strokeWidth={Math.max(2, Math.min(4, r * 0.3))} />
                      <text x={q.x} y={q.y + 4} textAnchor="middle" fill="#fff"
                            fontSize={11} fontWeight={700}>G{i + 1}</text>
                    </g>
                  );
                })}
              </>
            )}
          />

          <div className="legende">
            {d.oberflaechen.map((o: any) => (
              <span key={o.wert}>
                <i style={{ background: o.farbe }} />{o.text}
              </span>
            ))}
            <span><i className="gestrichelt" />Leerrohr liegt</span>
          </div>

          <p className="klein leise">
            <b>Ziehen</b> verschiebt die Karte, <b>Klick</b> setzt einen Punkt.
            <b> Weg:</b> Klick für Klick vom Rohrverband bis ins Haus, grob
            genügt. <b>Montagegrube:</b> auf die Stelle klicken, an der geöffnet
            wird. Die Zeichnung sehen auch die Partner in der Akte
            (ab .455); Stunden und Tage bleiben <b>im Haus</b>.
          </p>
        </div>

        <div className="spalte schmal">
          <div className="karte">
            <h3>Abschnitte und Gruben</h3>
            <div className="leib" style={{ padding: 0 }}>
              {!abschnitte.length && !gruben.length ? (
                <p className="klein leise" style={{ padding: '14px 16px', margin: 0 }}>
                  Zeichne den Graben, dann stehen hier die Abschnitte.
                </p>
              ) : (
                <table className="liste">
                  <tbody>
                    {abschnitte.map((a, i) => (
                      <tr key={i} style={{ cursor: 'default' }}
                          className={a.handisch ? 'handisch' : undefined}>
                        <td style={{ width: 34 }}>
                          <span className="nrkreis">{i + 1}</span>
                        </td>
                        <td className="zahl" style={{ width: 56 }}>
                          {z1(gerechnet!.zeilen[i].meter)}
                        </td>
                        <td>
                          <select className="klein" style={{ width: '100%' }}
                                  value={a.klasse}
                                  disabled={a.leerrohr}
                                  onChange={(e) => {
                                    setKlassen((k) => ({ ...k, [i]: e.target.value }));
                                    setHandisch((h) => ({ ...h, [i]: true }));
                                  }}>
                            {d.oberflaechen.map((o: any) => (
                              <option key={o.wert} value={o.wert}>{o.text}</option>
                            ))}
                          </select>
                          {/* DAS LEERROHR IST EIN KÄSTCHEN MIT AUFSCHRIFT.
                           *
                           * ORIGINALTEXT MARVIN (06.09.2026)
                           *   „bei «Abschnitte und Gruben» fehlt der punkt
                           *    Leehrrohr mit der Checkbox."
                           *
                           * .111 hatte es in die Oberflächen-Auswahl gelegt -
                           * „eine Frage, eine Auswahl" - und der Auftraggeber
                           * hat anders entschieden. Es steht wieder als
                           * eigener Punkt da, und die Lehre von damals bleibt:
                           * **es trägt seine Aufschrift NEBEN sich und nicht
                           * in einem Tooltip.** Ein Tooltip gibt es auf dem
                           * Telefon nicht, und genau das war der Grund, warum
                           * das alte Kästchen niemand gefunden hat.
                           *
                           * Die Auswahl darüber wird dabei GESPERRT und nicht
                           * geleert: wer den Haken wieder wegnimmt, findet
                           * seine Oberfläche vor, statt sie neu zu suchen.
                           * Und der Wert bleibt erhalten - **nichts
                           * verschwindet still.** */}
                          <label className="leerrohrhaken">
                            <input type="checkbox" checked={a.leerrohr}
                                   onChange={(e) => setLeerrohr(
                                     (l) => ({ ...l, [i]: e.target.checked }))} />
                            Leerrohr liegt
                          </label>
                          <div className="klein leise">
                            {a.leerrohr ? 'wird eingezogen, nicht gegraben'
                             : a.handisch
                               ? `von Hand${a.vorschlag
                                   ? `, Vorschlag war ${d.oberflaechen.find(
                                       (o: any) => o.wert === a.vorschlag)?.text}` : ''}`
                               : a.sicherheit
                                 ? `Vorschlag, ${a.sicherheit} % sicher`
                                 : 'kein Vorschlag'}
                          </div>
                        </td>
                        <td className="zahl" style={{ width: 46 }}>
                          {z1(gerechnet!.zeilen[i].stunden)}
                        </td>
                      </tr>
                    ))}
                    {gruben.map((g, i) => (
                      <tr key={'g' + i} style={{ cursor: 'default' }} className="grube">
                        <td><span className="nrkreis grube">G{i + 1}</span></td>
                        <td className="zahl klein leise">Grube</td>
                        <td>
                          {/* KEIN „Leerrohr liegt" AN EINER GRUBE. Ein Rohr
                              wird durch einen Graben eingezogen; eine Grube
                              wird geöffnet, sonst ist sie keine. Ein Wert, der
                              nichts bedeuten kann, gehört nicht in die
                              Auswahl. */}
                          <select className="klein" style={{ width: '100%' }}
                                  value={g.klasse}
                                  onChange={(e) => setGruben((alt) => alt.map(
                                    (x, j) => j === i
                                      ? { ...x, klasse: e.target.value, handisch: true }
                                      : x))}>
                            {d.oberflaechen.map((o: any) => (
                              <option key={o.wert} value={o.wert}>{o.text}</option>
                            ))}
                          </select>
                          {/* DIE HERKUNFT DER OBERFLÄCHE STEHT AUCH HIER.
                              Sie stand bis .99 nur an den Abschnitten - und
                              die Grube hatte gar keine, weil sie nie
                              abgetastet wurde. Ohne diese Zeile ist ein
                              Vorschlag von einer gemessenen Angabe nicht zu
                              unterscheiden. */}
                          <div className="klein leise">
                            {g.handisch
                              ? `von Hand${grubenVorschlag[i]
                                  ? `, Vorschlag war ${d.oberflaechen.find(
                                      (o: any) => o.wert === grubenVorschlag[i].klasse
                                    )?.text}` : ''}`
                              : grubenVorschlag[i]
                                ? `Vorschlag, ${grubenVorschlag[i].sicherheit} % sicher`
                                : 'kein Vorschlag'}
                          </div>
                        </td>
                        <td className="zahl">
                          {z1(d.werte.grube[g.klasse] ?? 0)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>

          <div className="feldreihe" style={{ marginTop: 10 }}>
            <label className="feld">
              <span className="titel">Hauseinführungen</span>
              <input type="number" min={0} value={hef} style={{ width: 70 }}
                     onChange={(e) => setHef(Math.max(0, Number(e.target.value)))} />
            </label>
            <span className="klein leise" style={{ alignSelf: 'end', paddingBottom: 8 }}>
              Gruben werden auf der Karte gesetzt.
            </span>
          </div>

          <div className="ergebnisbalken">
            <div><b>{z1(gerechnet!.meter)}</b><span>Meter</span></div>
            <div><b>{z1(gerechnet!.stunden)}</b><span>Stunden</span></div>
            <div><b>{z1(gerechnet!.tage)}</b><span>Tage</span></div>
          </div>

          <p className="klein leise">
            Gerechnet wird mit den Zeitwerten aus der Konfiguration, Bereich
            „Tiefbau-Schätzung". Gespeichert wird die Rechnung des Servers aus
            den Koordinaten.
          </p>

          {meldung ? (
            /* EIN SCHRITT, DER NICHTS MEHR ZU TUN LÄSST, BRAUCHT KEINEN
               KNOPF. Bis .111 stand hier „Zurück zum Auftrag" und schloss
               das zweite Fenster. Es gibt kein zweites Fenster mehr; wer
               fertig ist, schliesst „Auftrag vorbereiten" oder blättert
               zurück. */
            <div className="hinweis erledigt"><b>Übernommen</b>{meldung}</div>
          ) : (
            <button className="knopf haupt" disabled={laeuft}
                    onClick={uebernehmen}>
              {laeuft ? 'Einen Moment' : 'In den Auftrag übernehmen'}
            </button>
          )}
        </div>
      </div>
    </>
  );
}

/* HIER STAND `kartenkasten` EIN ZWEITES MAL.
 *
 * Zeichen für Zeichen dieselbe Rechnung wie im Lageplan, nur unter einem
 * anderen Namen. Sie steht jetzt in `teile/Kartenflaeche.tsx` - **zwei
 * Rahmen, die um Bruchteile auseinanderlaufen, holen zwei verschiedene Kästen
 * von Grenzen, und dann zeigt die eine Karte ein Flurstück, das die andere
 * nicht hat.** Dieselbe Lehre wie bei `ausschnittRahmen` auf dem Server.
 */
